export default __webpack_public_path__ + "4c34c77c497da7774887acee22f3cb20.png";